import { ModelDataType } from 'src/app/interfaces/model-data-type';

import { BaseModel } from './base-model';

export class CompanyPackagePricing extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static CompanyPackagePricingProperties: (
    | {
        property: keyof CompanyPackagePricing;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof CompanyPackagePricing;
        type: 'alias';
      }
    | {
        property: keyof CompanyPackagePricing;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'email', type: 'column', dataType: 'string' },
    { property: 'basePackagePrice', type: 'column', dataType: 'number' },
    {
      property: 'basePackagePriceRemittance',
      type: 'column',
      dataType: 'number'
    },
    { property: 'fullPackagePrice', type: 'column', dataType: 'number' },
    {
      property: 'fullPackagePriceRemittance',
      type: 'column',
      dataType: 'number'
    },
    {
      property: 'premiumPackagePricePerEmployee',
      type: 'column',
      dataType: 'number'
    },
    {
      property: 'premiumPackagePricePerEmployeeRemittance',
      type: 'column',
      dataType: 'number'
    },
    { property: 'packageWaiverAmount', type: 'column', dataType: 'number' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' },
    { property: 'CompanyId', type: 'column', dataType: 'number' }
  ];

  static {
    CompanyPackagePricing.CompanyPackagePricingProperties.forEach(
      (propertyObject) => {
        const { property, type } = propertyObject;
        if (type === 'column') {
          CompanyPackagePricing.columnMap.set(property, propertyObject);
        }
        if (type === 'alias') {
          CompanyPackagePricing.aliasedColumnMap.set(
            property,
            propertyObject as { property: string; type: 'alias' }
          );
        }
        if (type === 'association') {
          CompanyPackagePricing.associationMap.set(
            property,
            propertyObject as {
              property: string;
              type: 'association';
              model: string;
            }
          );
        }
      }
    );
  }

  constructor(CompanyPackagePricingObject: Partial<CompanyPackagePricing>) {
    super();

    CompanyPackagePricing.CompanyPackagePricingProperties.forEach(
      (propertyObject) => {
        const { property } = propertyObject;
        const value = CompanyPackagePricingObject[property];
        if (value !== undefined) {
          Object.assign(this, { [property]: value });
        }
      }
    );
  }

  id?: number;
  email?: string | null;
  basePackagePrice?: number | null;
  basePackagePriceRemittance?: number | null;
  fullPackagePrice?: number | null;
  fullPackagePriceRemittance?: number | null;
  premiumPackagePricePerEmployee?: number | null;
  premiumPackagePricePerEmployeeRemittance?: number | null;
  packageWaiverAmount?: number | null;
  createdAt?: Date;
  updatedAt?: Date;
  CompanyId?: number | null;
}
